export enum ServiceEventStatus {
  UNKOWN = 0,
  REGISTERED = 1,
  PLANNED = 2,
  DONE = 3,
  CANCELED = 4
}
